import React, { useMemo } from 'react';
import ProductCard from './ProductCard';

/**
 * Nota: anteriormente esta lista usaba `react-window` para virtualizar los
 * productos por performance. Sin embargo, `.carta-v7-products-card` usa
 * `display: grid` con `.carta-v7-product-row` como HIJO DIRECTO para acomodar
 * los productos en columnas (ver CartaRedesign.css). El wrapper que agrega
 * react-window rompía esa relación padre-hijo: el grid solo veía 1 hijo (el
 * contenedor de la lista virtualizada) y todos los productos quedaban
 * apilados verticalmente dentro de esa única celda, dejando el resto de las
 * columnas del grid vacías.
 *
 * Como las categorías del menú no manejan volúmenes que requieran
 * virtualización, se renderiza la lista completa de forma directa para que
 * el grid CSS funcione correctamente.
 */
const VirtualizedProductList = ({
  products = [],
  branchConfig,
  onAdd,
  onMinus,
  onProductClick,
  getProductQuantity,
}) => {
  const validProducts = useMemo(
    () => (products || []).filter((product) => product && product.id),
    [products]
  );

  if (validProducts.length === 0) {
    return (
      <div className="carta-v7-empty">
        <p>No hay productos disponibles</p>
      </div>
    );
  }

  return (
    <div className="carta-v7-products-card">
      {validProducts.map((product, index) => (
        <ProductCard
          key={product.id}
          product={product}
          branchConfig={branchConfig}
          onAdd={() => onAdd(product)}
          onMinus={() => onMinus(product.id)}
          onProductClick={onProductClick}
          count={parseInt(getProductQuantity(product.id) || 0, 10)}
          isLast={index === validProducts.length - 1}
        />
      ))}
    </div>
  );
};

export default VirtualizedProductList;
